module.exports = __webpack_public_path__ + "img/Logo_Mitta_Black.e08f709c.png";